import { WebLayout } from 'components/Layout';
import React, { useEffect } from 'react';

export const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <WebLayout>
      <div className="p-8 px-8 md:px-56 dark:text-white">
        <div className="text-center md:text-start mb-10">
          <h1 className="text-4xl league-spartan-extra-bold md:text-7xl text-black dark:text-white">
            Terms of <span className="text-[#F9A200]">Service.</span>
          </h1>
          <p className="text-xl mt-4">
            Welcome to Ashita Creatives. By using our website, products, or services, you agree to
            the following terms and conditions.
          </p>
        </div>

        <div className="space-y-10">
          <section>
            <h2 className="text-3xl league-spartan-bold mb-4">1. Acceptance of Terms</h2>
            <p className="text-lg">
              By accessing any service, platform, or product from Ashita Creatives, you acknowledge
              that you have read, understood, and agreed to these Terms of Service and our Privacy
              Policy.
            </p>
          </section>

          <section>
            <h2 className="text-3xl league-spartan-bold mb-4">2. Services Offered</h2>
            <p className="text-lg mb-3">
              Ashita Creatives provides design-driven software and product development services,
              including:
            </p>
            <ul className="list-disc list-inside space-y-2 text-lg">
              <li>Fintech & protocol-based product design (e.g., LonaPay)</li>
              <li>Commerce platforms with cultural integrations (e.g., tribeTee™)</li>
              <li>Web & Mobile App Development</li>
              <li>Product Strategy & MVP Prototyping</li>
              <li>UI/UX Design for Web and Mobile</li>
              <li>Security-first System Architecture</li>
              <li>Legal-tech consultations and compliance</li>
            </ul>
            <p className="text-lg mt-4">
              Each project or product will be governed by an individual contract or agreement.
            </p>
          </section>

          <section>
            <h2 className="text-3xl league-spartan-bold mb-4">3. User Responsibilities</h2>
            <p className="text-lg mb-2">Users of our services must agree to:</p>
            <ul className="list-disc list-inside space-y-2 text-lg">
              <li>Provide accurate, complete, and current information.</li>
              <li>Not misuse our services for unlawful or malicious activity.</li>
              <li>Respect the intellectual property and terms outlined in each contract.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-3xl league-spartan-bold mb-4">4. Payment Terms</h2>
            <p className="text-lg">
              Payments must be made as per the schedule outlined in your service agreement. Late
              payments may result in delays, service interruptions, or cancellation of access.
            </p>
          </section>

          <section>
            <h2 className="text-3xl league-spartan-bold mb-4">5. Intellectual Property</h2>
            <p className="text-lg">
              All designs, code, systems, and content created by Ashita remain the intellectual
              property of Ashita until full payment is received. For product partnerships or
              licensing deals, ownership and licensing rights will be explicitly agreed upon in
              writing.
            </p>
          </section>

          <section>
            <h2 className="text-3xl league-spartan-bold mb-4">6. Platform Use (Products)</h2>
            <p className="text-lg">
              For users of Ashita-built platforms (e.g., LonaPay, tribeTee™), use is subject to
              additional product-specific terms. Misuse, data scraping, and reverse engineering of
              our platforms is prohibited.
            </p>
          </section>

          <section>
            <h2 className="text-3xl league-spartan-bold mb-4">7. Limitation of Liability</h2>
            <p className="text-lg">
              Ashita Creatives is not liable for indirect or consequential damages resulting from
              use of our services. Our total liability for any claim is limited to the amount paid
              for the service in question.
            </p>
          </section>

          <section>
            <h2 className="text-3xl league-spartan-bold mb-4">8. Termination of Services</h2>
            <p className="text-lg">
              We reserve the right to terminate access to services for violations of these terms,
              breach of contract, or unethical behavior. You may also request cancellation with
              written notice.
            </p>
          </section>

          <section>
            <h2 className="text-3xl league-spartan-bold mb-4">9. Remote Teams & Collaboration</h2>
            <p className="text-lg">
              Ashita operates primarily through remote teams. Clients agree to collaborate via
              designated channels, honor communication timelines, and provide clear deliverable
              feedback.
            </p>
          </section>

          <section>
            <h2 className="text-3xl league-spartan-bold mb-4">10. Modifications to Terms</h2>
            <p className="text-lg">
              Ashita may revise these Terms at any time. We will notify users via the website or
              email. Continued use of our services after updates constitutes acceptance of the
              changes.
            </p>
          </section>

          <section>
            <h2 className="text-3xl league-spartan-bold mb-4">11. Governing Law</h2>
            <p className="text-lg">
              These terms are governed by the laws of the Republic of Uganda. Disputes will be
              resolved in Ugandan courts or through mutually agreed mediation first.
            </p>
          </section>

          <section>
            <h2 className="text-3xl league-spartan-bold mb-4">12. Contact Us</h2>
            <p className="text-lg mb-2">For questions or legal inquiries, contact us:</p>
            <p className="text-lg">
              Email:{' '}
              <a href="mailto:ashitacreatives@gmail.com" className="text-[#F9A200] hover:underline">
                ashitacreatives@gmail.com
              </a>{' '}
              <br />
              Phone: +256 782 692 271
            </p>
            <div className="mt-12 text-sm text-gray-600 dark:text-gray-400">
              Last Updated: 18 May, 2025
            </div>
          </section>
        </div>
      </div>
    </WebLayout>
  );
};
